module.exports = __webpack_public_path__ + "img/partners2.f76f789c.jpg";